var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-account" }, [
    _c(
      "div",
      {
        staticClass: "container",
        class: [_vm.fullWidth > 768 ? "containerSamll" : "containerBig"],
      },
      [
        _c(
          "div",
          { staticClass: "index_from page-account-container" },
          [
            _vm.loginType == 1
              ? [
                  _c(
                    "div",
                    { staticClass: "page-account-top page-code-top" },
                    [
                      !_vm.codeShowLogin
                        ? _c(
                            "el-tabs",
                            {
                              on: { "tab-click": _vm.tabChange },
                              model: {
                                value: _vm.activeName,
                                callback: function ($$v) {
                                  _vm.activeName = $$v
                                },
                                expression: "activeName",
                              },
                            },
                            [
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("login.passwordlogin"),
                                  name: "passwordLogin",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("login.smslogin"),
                                  name: "cmsLogin",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.codeShowLogin
                        ? _c(
                            "el-tabs",
                            [
                              _c("el-tab-pane", {
                                attrs: { label: "扫码登录", name: "codeLogin" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.codeShowLogin
                    ? _c(
                        "el-form",
                        {
                          ref: "loginForm",
                          staticClass: "login-form",
                          attrs: {
                            model: _vm.loginForm,
                            rules: _vm.loginRules,
                            autocomplete: "on",
                            "label-position": "left",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleLogin($event)
                            },
                          },
                        },
                        [
                          _vm.activeName == "passwordLogin"
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "account" } },
                                  [
                                    _c("el-input", {
                                      ref: "account",
                                      attrs: {
                                        placeholder: _vm.$t("login.phone"),
                                        autocomplete: "on",
                                        name: "username",
                                        "prefix-icon": "el-icon-user",
                                        tabindex: "1",
                                        type: "text",
                                      },
                                      model: {
                                        value: _vm.loginForm.account,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.loginForm,
                                            "account",
                                            $$v
                                          )
                                        },
                                        expression: "loginForm.account",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "password" } },
                                  [
                                    _c("el-input", {
                                      key: _vm.passwordType,
                                      ref: "password",
                                      attrs: {
                                        placeholder: _vm.$t("login.password"),
                                        type: _vm.passwordType,
                                        "auto-complete": "on",
                                        name: "password",
                                        "prefix-icon": "el-icon-lock",
                                        tabindex: "2",
                                      },
                                      model: {
                                        value: _vm.loginForm.password,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.loginForm,
                                            "password",
                                            $$v
                                          )
                                        },
                                        expression: "loginForm.password",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "pwd",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handelTabTagger(3)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          {
                                            attrs: {
                                              underline: false,
                                              type: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("login.forgetpassword")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "captcha",
                                    attrs: { prop: "captcha" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "captcha" },
                                      [
                                        _c("el-input", {
                                          ref: "username",
                                          staticStyle: { width: "199px" },
                                          attrs: {
                                            placeholder: _vm.$t("login.code"),
                                            autocomplete: "on",
                                            name: "username",
                                            "prefix-icon": "el-icon-message",
                                            tabindex: "3",
                                            type: "text",
                                          },
                                          model: {
                                            value: _vm.loginForm.captcha,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.loginForm,
                                                "captcha",
                                                $$v
                                              )
                                            },
                                            expression: "loginForm.captcha",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "imgs",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getCaptcha()
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              attrs: { src: _vm.captchatImg },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeName == "cmsLogin"
                            ? [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "phone" } },
                                  [
                                    _c("el-input", {
                                      ref: "phone",
                                      attrs: {
                                        placeholder: _vm.$t("login.phone"),
                                        autocomplete: "on",
                                        name: "phone",
                                        "prefix-icon": "el-icon-mobile-phone",
                                        tabindex: "1",
                                        type: "text",
                                      },
                                      model: {
                                        value: _vm.loginForm.phone,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.loginForm, "phone", $$v)
                                        },
                                        expression: "loginForm.phone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "verification_code" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "item-box" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("el-input", {
                                              key: _vm.passwordType,
                                              ref: "password",
                                              attrs: {
                                                placeholder:
                                                  _vm.$t("login.codetitle"),
                                                "auto-complete": "on",
                                                name: "password",
                                                "prefix-icon": "el-icon-lock",
                                                tabindex: "2",
                                                type: "text",
                                              },
                                              model: {
                                                value:
                                                  _vm.loginForm
                                                    .verification_code,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.loginForm,
                                                    "verification_code",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "loginForm.verification_code",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "button",
                                            attrs: {
                                              disabled: _vm.disabled,
                                              type: "primary",
                                            },
                                            on: { click: _vm.code },
                                          },
                                          [_vm._v(_vm._s(_vm.text))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "30px",
                              },
                              attrs: { loading: _vm.loading, type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleLogin($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("login.logIn")) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.codeShowLogin
                    ? _c("div", { staticClass: "code-content" }, [
                        !_vm.codeSuccess
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.codeLoading,
                                      expression: "codeLoading",
                                    },
                                  ],
                                  staticClass: "code-header",
                                },
                                [
                                  _c("div", {
                                    ref: "QRCode_header",
                                    staticClass: "QRCode_header",
                                  }),
                                  _vm._v(" "),
                                  _vm.sitedata.site_logo
                                    ? _c("img", {
                                        staticClass: "image-code-logo",
                                        attrs: {
                                          src: _vm.sitedata.site_logo,
                                          alt: "",
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "image-code-logo",
                                        attrs: {
                                          alt: "",
                                          src: require("../../assets/images/code-logo.png"),
                                        },
                                      }),
                                  _vm._v(" "),
                                  _vm.codeButton
                                    ? _c(
                                        "div",
                                        { staticClass: "code-model" },
                                        [
                                          _c("div", { staticClass: "text" }, [
                                            _vm._v("二维码失效"),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                round: "",
                                                size: "mini",
                                                type: "primary",
                                              },
                                              on: { click: _vm.getUserKey },
                                            },
                                            [_vm._v("刷新二维码")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "code-tip" }, [
                                _vm._v("请使用陀螺匠App扫码"),
                              ]),
                            ])
                          : _c("div", { staticClass: "success-code" }, [
                              _c("i", {
                                staticClass: "el-icon-circle-check icon",
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "success-text" }, [
                                _vm._v("扫码成功"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "success-text1 code-tip" },
                                [_vm._v("请在手机上根据提示确认登录")]
                              ),
                            ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeName === "passwordLogin" && !_vm.codeShowLogin
                    ? _c("div", { staticClass: "text" }, [
                        _vm._v("未注册用户请联系管理员创建"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeName === "cmsLogin" && !_vm.codeShowLogin
                    ? _c("div", { staticClass: "text" }, [
                        _vm._v("未注册用户请联系管理员创建"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-login-code",
                      attrs: { size: "small" },
                      on: { click: _vm.imageCode },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.codeShowLogin ? "账号登录" : "扫码登录")
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "image-login-code",
                    attrs: {
                      src: _vm.codeShowLogin
                        ? require("@/assets/images/login-account.png")
                        : require("@/assets/images/login-code.png"),
                      alt: "",
                    },
                    on: { click: _vm.imageCode },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.loginType == 2
              ? [
                  _c(
                    "div",
                    { staticClass: "page-account-top" },
                    [
                      _c("div", { staticClass: "title-box" }, [
                        _vm._v(_vm._s(_vm.$t("login.zhuce"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "loginForm",
                          staticClass: "login-form",
                          attrs: {
                            model: _vm.loginForm,
                            rules: _vm.loginRules,
                            autocomplete: "on",
                            "label-position": "left",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleLogin($event)
                            },
                          },
                        },
                        [
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "phone" } },
                              [
                                _c("el-input", {
                                  ref: "phone",
                                  attrs: {
                                    placeholder: _vm.$t("login.title1"),
                                    autocomplete: "on",
                                    name: "phone",
                                    "prefix-icon": "el-icon-mobile-phone",
                                    tabindex: "1",
                                    type: "text",
                                  },
                                  model: {
                                    value: _vm.loginForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "phone", $$v)
                                    },
                                    expression: "loginForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "verification_code" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item-box" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          key: _vm.passwordType,
                                          ref: "password",
                                          attrs: {
                                            placeholder:
                                              _vm.$t("login.codetitle"),
                                            "auto-complete": "on",
                                            name: "password",
                                            "prefix-icon": "el-icon-lock",
                                            tabindex: "2",
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.loginForm.verification_code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.loginForm,
                                                "verification_code",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "loginForm.verification_code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          type: "primary",
                                        },
                                        on: { click: _vm.code },
                                      },
                                      [_vm._v(_vm._s(_vm.text))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "password" } },
                              [
                                _c("el-input", {
                                  key: _vm.passwordType,
                                  ref: "password",
                                  attrs: {
                                    placeholder: _vm.$t("login.title2"),
                                    type: _vm.passwordType,
                                    "auto-complete": "on",
                                    name: "password",
                                    "prefix-icon": "el-icon-lock",
                                    tabindex: "2",
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-pwd",
                                    on: { click: _vm.showPwd },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        "icon-class":
                                          _vm.passwordType === "password"
                                            ? "eye"
                                            : "eye-open",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "30px",
                              },
                              attrs: { loading: _vm.loading, type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleRegister($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("login.register")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tips-btn" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("login.title3")) +
                              "\n            "
                          ),
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                "margin-top": "-3px",
                                "margin-left": "5px",
                              },
                              attrs: { underline: false, type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handelTabTagger(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("login.logIn")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.loginType == 3
              ? [
                  _c(
                    "div",
                    { staticClass: "page-account-top" },
                    [
                      _c("div", { staticClass: "title-box" }, [
                        _vm._v(_vm._s(_vm.$t("login.title4"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          ref: "loginForm",
                          staticClass: "login-form",
                          attrs: {
                            model: _vm.loginForm,
                            rules: _vm.loginRules,
                            autocomplete: "on",
                            "label-position": "left",
                          },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleLogin($event)
                            },
                          },
                        },
                        [
                          [
                            _c(
                              "el-form-item",
                              { attrs: { prop: "phone" } },
                              [
                                _c("el-input", {
                                  ref: "phone",
                                  attrs: {
                                    placeholder: _vm.$t("login.title1"),
                                    autocomplete: "on",
                                    name: "phone",
                                    "prefix-icon": "el-icon-mobile-phone",
                                    tabindex: "1",
                                    type: "text",
                                  },
                                  model: {
                                    value: _vm.loginForm.phone,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.loginForm,
                                        "phone",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "loginForm.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "verification_code" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "item-box" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          key: _vm.passwordType,
                                          ref: "password",
                                          attrs: {
                                            placeholder:
                                              _vm.$t("login.codetitle"),
                                            "auto-complete": "on",
                                            name: "password",
                                            "prefix-icon": "el-icon-lock",
                                            tabindex: "2",
                                            type: "text",
                                          },
                                          model: {
                                            value:
                                              _vm.loginForm.verification_code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.loginForm,
                                                "verification_code",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "loginForm.verification_code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          disabled: _vm.disabled,
                                          type: "primary",
                                        },
                                        on: { click: _vm.code },
                                      },
                                      [_vm._v(_vm._s(_vm.text))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { prop: "password" } },
                              [
                                _c("el-input", {
                                  key: _vm.passwordType,
                                  ref: "password",
                                  attrs: {
                                    placeholder: _vm.$t("login.title2"),
                                    type: _vm.passwordType,
                                    "auto-complete": "on",
                                    name: "password",
                                    "prefix-icon": "el-icon-lock",
                                    tabindex: "2",
                                  },
                                  model: {
                                    value: _vm.loginForm.password,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.loginForm, "password", $$v)
                                    },
                                    expression: "loginForm.password",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "show-pwd",
                                    on: { click: _vm.showPwd },
                                  },
                                  [
                                    _c("svg-icon", {
                                      attrs: {
                                        "icon-class":
                                          _vm.passwordType === "password"
                                            ? "eye"
                                            : "eye-open",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "30px",
                              },
                              attrs: { loading: _vm.loading, type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleResetPwd($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("login.ok")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tips-btn" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("login.title3")) +
                              "\n            "
                          ),
                          _c(
                            "el-link",
                            {
                              staticStyle: {
                                "margin-top": "-3px",
                                "margin-left": "5px",
                              },
                              attrs: { underline: false, type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.handelTabTagger(1)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("login.logIn")) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "foot-bar" }, [
      _c("p", [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("login.contactnumber")) +
            "：" +
            _vm._s(_vm.sitedata.site_tel) +
            " " +
            _vm._s(_vm.$t("login.addresss")) +
            "：" +
            _vm._s(_vm.sitedata.site_address) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.sitedata.site_record_number))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }